import {
  publish,
  saveDraft,
  modifyDraft,
  saveDiary,
  modifyDiary,
  unbindFile,
  getOnlineImgs,
} from '../../../api'
import Quill from 'quill'
import { editorTypeDict, embedType } from '../../../util/dict'
import { Toast } from 'antd-mobile'
import qs from 'qs'
import { sensorSendCreateDiary } from '../../../sensor'

let loading = false

const { flutter } = qs.parse(window.location.search.substr(1)) as {
  flutter: string | undefined
}

function getRecordId() {
  return (
    window.localStorage.getItem('recordId') ||
    window.localStorage.getItem('newRecordId')
  )
}

interface GetPublishParams {
  checkFiles: CheckFilesFn
  fileDict: React.MutableRefObject<FileDict>
  imgDict: React.MutableRefObject<{
    [k: string]: string
  }>
  tempId: React.MutableRefObject<number>
  taskId: React.MutableRefObject<string>
  isNullRef: React.MutableRefObject<boolean>
  editorRef: React.MutableRefObject<Quill | null>
}

function clearUselessInfo() {
  window.localStorage.removeItem('fileInfo')
  window.localStorage.removeItem('content')
  window.localStorage.removeItem('draftId')
  window.localStorage.removeItem('recordId')
  window.localStorage.removeItem('detailTaskId')
  window.localStorage.removeItem('isNote')
  window.localStorage.removeItem('diaryLocalInfo')
  window.localStorage.removeItem('newRecordId')
  window.localStorage.removeItem('taskId')
  window.localStorage.removeItem('dispatchId')
  window.localStorage.removeItem('compareParams')
  window.localStorage.removeItem('inputTitle')
  window.localStorage.removeItem('ogFileIds')
  window.localStorage.removeItem('sharedDiary')
}

function getBindId() {
  const recordId =
      window.localStorage.getItem('recordId') ||
      window.localStorage.getItem('newRecordId'),
    taskId = window.localStorage.getItem('detailTaskId')

  let tuple: ['record' | 'task', string] | undefined

  if (recordId) {
    tuple = ['record', recordId]
  }

  if (taskId) {
    tuple = ['task', taskId]
  }

  return tuple
}

async function getImgDict({
  imgDict,
}: {
  imgDict?: React.MutableRefObject<{
    [k: string]: string
  }>
}) {
  const list: { uniId: string; id: string }[] = []
  const imgDoms = document.querySelectorAll('.blot-common_img[data-file]'),
    imgUrls = [...imgDoms].map(
      (node) => node.getAttribute('data-file') as string
    )

  if (imgUrls.length) {
    let urlDict = await getOnlineImgs(imgUrls)
    Object.keys(urlDict).forEach((k) => {
      console.log(urlDict, urlDict[k])
      if (typeof urlDict[k] === 'object' && urlDict[k].code === 40025) {
        urlDict[k] = './images/icon-file/icon-file-error.png'
      }
    })
    imgDoms.forEach((node) => {
      const dom = node as HTMLLinkElement
      const fileId = dom.getAttribute('data-file') as string
      if (imgDict) {
        imgDict.current[fileId] = urlDict[fileId]
      }
      dom.style.backgroundImage = `url('${urlDict[fileId]}')`
      const { uniId } = qs.parse(node.getAttribute('href') as string) as {
        uniId: string
        id: string
      }
      list.push({
        uniId,
        id: fileId,
        // url: dom.style.backgroundImage.replace('url("', '').replace('")', ''),
      })
    })
  }

  return list
}

function convertParams(params: PublishParams) {
  const { affected_uid } = params
  const title = window.localStorage.getItem('inputTitle') || ''

  const taskId = window.localStorage.getItem('taskId')
  const dispatchId = window.localStorage.getItem('dispatchId')

  const p: DiaryParams = {
    ...params,
    title,
    remind_user_id: affected_uid,
    record_type: 0,
  }

  if (taskId && dispatchId) {
    // 事项记录
    p.ref_task = {
      ref_dispatch_id: dispatchId,
      ref_task_id: taskId,
    }
    p.record_type = 1
  }

  return p
}

const goPublish = async ({
  params,
  draftId,
  needRedirect,
  setDisplay,
  setLoading,
  confirmToSave,
  displayImgs,
}: {
  params: PublishParams
  draftId?: string
  needRedirect: boolean
  setDisplay?: (t: boolean) => void
  setLoading: (b: boolean) => void
  confirmToSave?: boolean
  displayImgs?: React.MutableRefObject<
    {
      uniId: string
      id: string
    }[]
  >
}) => {
  try {
    const taskId = window.localStorage.getItem('taskId')
    if (taskId) {
      params.ref_id = taskId
    }
    confirmToSave && setLoading(true)
    switch (window.localStorage.getItem('editorType')) {
      // 事项结论
      case editorTypeDict.MATTER: {
        await publish(params)
        window.localStorage.removeItem(`draft-conclusion-${taskId}`)
        needRedirect &&
          wx.miniProgram.redirectTo({
            url: `/pages/task/pages/matter-conclusion/index?taskId=${taskId}&fromH5=1`,
          })
        break
      }
      // 保存纪要草稿
      case editorTypeDict.MEETING: {
        if (draftId) {
          await modifyDraft(params, draftId)
        } else {
          await saveDraft(params)
        }
        needRedirect &&
          wx.miniProgram.redirectTo({
            url: `/pages/task/pages/meeting-summary/index?taskId=${taskId}&fromH5=1`,
          })
        break
      }
      // 保存个人笔记
      case editorTypeDict.DIARY: {
        loading = true

        const recordId = getRecordId()

        const compareParams = window.localStorage.getItem('compareParams')

        const p: DiaryParams = convertParams(params)

        const newParams = JSON.stringify({ title: p.title, content: p.content })

        const confirm = async () => {
          if (!needRedirect) return
          if (window.localStorage.getItem('sharedDiary')) {
            // 从分享笔记来
            wx.miniProgram.navigateBack()
            return
          }
          // 保存回到展示页面 -- 不返回
          let recordId = getRecordId()
          if (recordId) {
            window.localStorage.setItem('recordId', recordId)
          }
          if (displayImgs) displayImgs.current = await getImgDict({})
          setDisplay && setDisplay(true)
        }

        if (newParams === compareParams) {
          await confirm()
          loading = false
          return
        }

        console.log('check diary content', p.content)

        if (recordId) {
          // 编辑笔记
          // 解绑删除的文件
          const ogFiles = window.localStorage.getItem('ogFileIds')
          let delFiles: string[] = []
          if (ogFiles) {
            const paramsFiles = p.file_id,
              ogs = JSON.parse(ogFiles) as string[]
            delFiles = paramsFiles
              ? ogs.filter((id) => !paramsFiles.includes(id))
              : ogs
          }

          if (delFiles.length) {
            await unbindFile({
              file_id: delFiles,
              flyele_type: 'record',
              flyele_id: recordId,
            })
          }

          await modifyDiary(p, recordId)
          // 清除本地缓存
          window.localStorage.removeItem(`draft-diary-${recordId}`)
          // 更新已绑定的文件
          window.localStorage.setItem(
            'ogFileIds',
            JSON.stringify(p.file_id || [])
          )
        } else {
          // 新建笔记
          const res = await saveDiary(p)
          if (res) {
            const { record_id } = res

            // sensorSendCreateDiary({
            //   notes_id: record_id,
            //   has_title: !!p.title,
            //   has_detail:
            //     !!p.content && JSON.parse(p.content).html !== '<p><br></p>',
            //   // has_file: !!p.file_id?.length || !!p.image_id?.length,
            //   // has_related_issue: !!p.ref_task,
            //   // is_quote: !!p.remind_user_id,
            // })
            // 清除本地缓存
            window.localStorage.removeItem(`draft-diary-new`)
            window.localStorage.setItem('newRecordId', record_id)
            // 更新已绑定的文件
            window.localStorage.setItem(
              'ogFileIds',
              JSON.stringify(p.file_id || [])
            )

            const params = { ...p, record_id }

            // 新建笔记埋点
            if (flutter) {
              window.location = (`js://webview?trigger=new_diary&i=${JSON.stringify(
                params
              )}` as unknown) as Location
            } else {
              wx.miniProgram.postMessage({
                data: {
                  setDiary: ['noteAdd', record_id],
                  confirmParams: params,
                },
              })
            }

            // wx.miniProgram.postMessage({
            //   data: { setDiary: ['noteAdd', record_id] },
            // })
          }
        }
        // 保存成功后写入本地比对缓存
        window.localStorage.setItem('compareParams', newParams)

        await confirm()

        loading = false

        break
      }
    }
  } finally {
    loading = false
    setLoading(false)
  }
}

const autoSave = (
  getPublishParamsFn: GetPublishParamsFn,
  editorType: EditorType,
  displayRef: React.MutableRefObject<boolean>,
  setLoading: (b: boolean) => void
) => {
  // 保存至本地 -> 事项结论
  if (editorType === editorTypeDict.MATTER) {
    setInterval(async () => {
      const params = await getPublishParamsFn(true)
      if (!params) return

      const { content, ref_id } = params
      // 清除未上传的文件后保存草稿
      window.localStorage.setItem(
        `draft-conclusion-${ref_id}`,
        content.replace(/<a(.*)hrefId(.*)<\/a>/g, '')
      )
    }, 10000)
  }
  // 保存至服务器 -> 会议纪要
  if (editorType === editorTypeDict.MEETING) {
    setInterval(async () => {
      const params = await getPublishParamsFn(true)
      if (!params) return

      goPublish({
        params,
        draftId: window.localStorage.getItem('draftId') || '',
        needRedirect: false,
        setLoading,
      })
    }, 3 * 60 * 1000)
  }
  // 笔记
  if (editorType === editorTypeDict.DIARY) {
    const saveDiaryQuietly = async () => {
      const params = await getPublishParamsFn(true)
      if (!params || displayRef.current) return
      if (loading) {
        await new Promise((resolve) => {
          setTimeout(resolve, 500)
        })
      }

      goPublish({
        params,
        needRedirect: false,
        setLoading,
      })
    }

    const saveDiaryToLocal = async () => {
      const params = await getPublishParamsFn(true)
      if (!params || displayRef.current) return
      const diaryId =
        window.localStorage.getItem('recordId') ||
        window.localStorage.getItem('newRecordId')

      const draftId = diaryId ? `draft-diary-${diaryId}` : 'draft-diary-new'

      const p = JSON.stringify({
        title: convertParams(params).title,
        content: convertParams(params).content,
      })

      if (p === window.localStorage.getItem('compareParams')) return

      window.localStorage.setItem(draftId, p)
    }

    setInterval(saveDiaryQuietly, 3 * 60 * 1000)

    setInterval(saveDiaryToLocal, 10000)

    return saveDiaryQuietly
  }
}

const getPublishParams = ({
  checkFiles,
  fileDict,
  imgDict,
  tempId,
  taskId,
  isNullRef,
  editorRef,
}: GetPublishParams): GetPublishParamsFn => async (
  clearUnuploadedFiles: Boolean
) => {
  // const newRecordId = window.localStorage.getItem('newRecordId')

  // if (
  //   window.localStorage.getItem('editorType') === editorTypeDict.DIARY &&
  //   newRecordId &&
  //   isNullRef.current
  // ) {
  //   debugger
  //   console.log('delete new record id!')
  //   // 删除临时笔记
  //   deleteDiary(newRecordId)
  //   // window.localStorage.removeItem('newRecordId')
  //   wx.miniProgram.postMessage({
  //     data: { setDiary: ['noteRemove', newRecordId] },
  //   })
  //   return
  // } else

  console.log('get text', editorRef.current?.getText())

  if (isNullRef.current) {
    if (window.localStorage.getItem('editorType') === editorTypeDict.DETAIL) {
      return {
        content: JSON.stringify({ html: '', tempId: 0 }),
        file_id: [],
        image_id: [],
        affected_uid: '',
        ref_id: taskId.current,
        desc: '',
      }
    }

    return
  }

  const result = await checkFiles({
    checkOnly: false,
    type: 'submit',
    clearUnuploadedFiles,
  })

  if (!result) {
    console.log('checkFiles fail', result)
    return
  }

  const {
    file_id,
    affected_uid,
    editor,
    image_id,
    files,
  } = result as CheckFilesObj

  let content = editor.root.innerHTML

  Object.values(fileDict.current).forEach(({ id, url, tempId }) => {
    if (id) {
      const linkReg = new RegExp(`id=hrefId-${tempId}`)
      content = content.replace(linkReg, `id=${id}`)
      if (url) {
        const urlReg = new RegExp(url, 'g')
        content = content.replace(urlReg, `needfix-${id}`)
      }
    }
  })

  Object.entries(imgDict.current).forEach(([id, url]: string[]) => {
    const r = url.split('?Expires=')[0]
    const urlReg = new RegExp(r + '.*?&quot;', 'g')
    content = content.replace(urlReg, `needfix-${id}&quot;`)
  })

  let desc = ''

  editorRef.current?.getContents().ops.forEach((op) => {
    const insert = op.insert

    if (typeof insert === 'string') {
      desc += insert
      return
    }

    if (typeof insert === 'object' && 'INSERT_FILE' in insert) {
      const obj = insert as {
        INSERT_FILE: {
          type: string
          text: string
        }
      }
      if (
        obj.INSERT_FILE.type === embedType.PEOPLE ||
        obj.INSERT_FILE.type === embedType.MATTER
      ) {
        desc += obj.INSERT_FILE.text
      }
    }
  })

  return {
    content: JSON.stringify({ html: content, tempId: tempId.current }),
    file_id: [...new Set(file_id)],
    image_id,
    affected_uid: [...new Set(affected_uid)].join(','),
    ref_id: taskId.current,
    desc: desc.substr(0, 400),
    files,
  }
}

const insertBlot = async <T>({
  insertIdx,
  files,
  editor,
  handler,
}: {
  insertIdx: number
  files: T[]
  editor: Quill
  handler: (file: T, insertIdx: number) => void
}) => {
  const ops = editor.getContents(insertIdx - 2, 2).ops

  if (!ops[0] || (typeof ops[0].insert === 'object' && ops[1].insert === ' ')) {
    // skip
  } else {
    editor.insertText(insertIdx++, '\n')
  }

  for (let file of files) {
    await handler(file, insertIdx)
    editor.setSelection(++insertIdx, 0)
    editor.insertText(insertIdx++, ' ')
  }

  const linefeed = editor.getContents(insertIdx, 1).ops[0].insert,
    isLastLine = !editor.getContents(insertIdx + 1, 1).ops[0]

  if (
    !isLastLine &&
    linefeed &&
    typeof linefeed === 'string' &&
    /\n/.test(linefeed)
  ) {
    // skip
  } else {
    editor.insertText(insertIdx++, '\n')
  }

  window.localStorage.setItem('focusIdx', insertIdx + '')
}

export {
  autoSave,
  getPublishParams,
  goPublish,
  insertBlot,
  clearUselessInfo,
  getBindId,
  getImgDict,
}
